import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { IBackofficeTask } from "../../utils/types/models";

export default createEntityReducer<IBackofficeTask>(Endpoint.BackofficeTasks, Endpoint.BackofficeTasksList);
